import React, { FC } from "react";

import PeopleIcon from "@mui/icons-material/PeopleAltOutlined";

import { classNames } from "../../../../utils/common/styling";

import { IProfile } from "./IProfile";
import { styles } from "./Profile.styles";
import { checkIsDefined } from "../../../../features/Common/modules/DataTypes/utils/nanNullUndef";
import { useCreatorThemeContext } from "../../../../features/Common/modules/Theme/CreatorThemeContext";
import { FALLBACK_COLOR } from "../../../../constants/common/common";

const Profile: FC<IProfile.IProps> = ({
  participants,
  photo,
  username,
  onClickPhoto,

  className,
  profilePicWrapperClassName,
  profilePicClassName,
  usernameClassName,
  participantsClassName,
  showPoweredByExly,
  membershipBadge,
}) => {
  const theme = useCreatorThemeContext();

  return (
    <div className={classNames(styles.root, className)}>
      {/* Profile image as overlay */}
      <div
        className={classNames(
          styles.profileImageContainer,
          profilePicWrapperClassName,
        )}
        onClick={onClickPhoto}
      >
        <img
          src={photo}
          alt=""
          className={classNames(styles.profileImage, profilePicClassName)}
        />
      </div>

      {/* Profile details */}

      <h1 className={classNames(styles.communityTitle, usernameClassName)}>
        {username}
      </h1>

      <div className={classNames(styles.profileDetailsContainer)}>
        {/* Membership Badge */}
        {membershipBadge && (
          <div className={styles.membershipBadge}>
            {membershipBadge.icon && (
              <div className={styles.badgeIcon}>{membershipBadge.icon}</div>
            )}
            <span className={styles.badgeText}>{membershipBadge.title}</span>
          </div>
        )}

        {showPoweredByExly && (
          <div className={styles.headingSuffix}>
            <span className={styles.poweredByText}>Powered by </span>
            <span className={styles.exlyText}>Exly</span>
          </div>
        )}

        {checkIsDefined(participants) && (
          <div
            className={classNames(
              styles.memberCountContainer,
              participantsClassName,
            )}
            style={{ color: theme?.colors?.color1 || FALLBACK_COLOR }}
          >
            <PeopleIcon
              style={{
                fontSize: 14,
                color: "#4a5568",
              }}
            />
            <span className={styles.memberCount}>
              {participants} {participants === 1 ? "Member" : "Members"}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
